import {Component, inject, DestroyRef} from '@angular/core';
import {JobsService} from '../../../services/http/admin/jobs.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {SHARED_IMPORTS} from "../../../shared/standalone-imports";

@Component({
  selector: 'app-admin-job-definition',
  templateUrl: './admin-job-definition.component.html',
  styleUrls: ['./admin-job-definition.component.less'],
  imports: [SHARED_IMPORTS]
})
export class AdminJobDefinitionComponent {
  private jobsService = inject(JobsService);
  private destroyRef = inject(DestroyRef);
  private destroy$ = new Subject<void>();

  constructor() {
    this.destroyRef.onDestroy(() => {
      this.destroy$.next();
      this.destroy$.complete();
    });
  }


  /** The definition of the selected job type. */
  jobDefinition: string;
  /** The name of the selected job. */
  jobName: string;

  /**
   * Retrieves job definition for {@link jobName}.
   * @param taskType the type of the task, for which the job definition is retrieved.
   */
  getJobDefinition(taskType: string) {
    this.jobsService.getJobDefinition(taskType)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: res => this.jobDefinition = res
            });
  }

  /**
   * Updates job definition for the given task type and then retrieves updated task details from backend.
   * @param taskType the type of task, for which the job definition should be updated.
   */
  changeDefinition(taskType: string) {
    const jobDefinition = prompt('Enter new job definition');
    if (jobDefinition) {
      this.jobsService.changeJobDefinition(taskType, jobDefinition)
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: () => this.getJobDefinition(taskType)
              });
    }
  }
}
